<template>
  <div class="box">
    <div class="main-content">
      <!-- 教材目录部分开始 -->
      <div class="classTimesList">
        <div v-for="(item, index) in catalogueList" :key="index">
          <div class="classTimesList-title-box flex align">
            <div class="classTimesList-block"></div>
            <div class="classTimesList-title">{{ item.name }}</div>
          </div>
          <div @click="selectCatalogue(index, index1)"
            :class="currentCatalogueIdx == index && currentCatalogueIdx1 == index1 ? 'allClasses' : 'classList'"
            v-for="(item, index1) in item.items" :key="index1">
            <div class="classList-circle"></div>
            <div class="classList-name">{{ item.name }}</div>
          </div>
        </div>
      </div>
      <!-- 教材目录部分结束 -->
      <!-- 教材纸质图片部分开始 -->
      <div class="paperImg-box">
        <div class="numberOfPages flex align spaceBetween">
          {{ textbookCataloguePaperList.length == 0 ? 0 : currentPaperIdx + 1 }}/{{ textbookCataloguePaperList.length
          }}页
          <div v-if="identity == 'developer'" class="flex align">
            <img @click="textbookUpload('批量')" class="textbookBatchUpload pointer"
              src="../../assets/textbookBatchUpload.png" alt="" />
            <img @click="textbookUpload('单个')" class="textbookUpload pointer" src="../../assets/textbookUpload.png"
              alt="" />
          </div>
        </div>
        <div v-if="identity == 'developer'" class="controls-box">
          <el-button @click="textbookUpload('修改')" type="primary" icon="el-icon-edit" circle></el-button>
          <el-button @click="textbookDel" type="danger" icon="el-icon-delete" circle></el-button>
        </div>
        <img v-if="textbookCataloguePaperList.length != 0" class="textbookPaper"
          :src="textbookCataloguePaperList[currentPaperIdx]?.assets?.content[0]" alt="" />
        <img v-if="currentPaperIdx != 0" @click="iconLeftToggle" class="iconLeftToggle pointer"
          src="../../assets/iconLeftToggle.png" alt="" />
        <img v-if="currentPaperIdx < textbookCataloguePaperList.length - 1" @click="iconRightToggle"
          class="iconRightToggle pointer" src="../../assets/iconRightToggle.png" alt="" />
      </div>
      <!-- 教材纸质图片部分结束 -->
      <!-- 侧边栏资源数据部分开始 -->
      <div class="sidebar-box">
        <div class="numberOfPages flex align spaceBetween">
          <div></div>
          <img v-if="identity == 'developer'" @click="addFromResource" class="addFromResource pointer"
            src="../../assets/addFromResource.png" alt="" />
        </div>
        <div class="sidebar-content-roll">
          <div v-for="(items, index) in sidebarList" :key="index" class="sidebar-content">
            <div class="classTimesList-title-box flex align">
              <div class="classTimesList-block"></div>
              <div class="classTimesList-title">{{ items.name }}</div>
            </div>
            <div v-for="(item, index1) in items.value" :key="index1" class="sidebarBox flex align">
              <div class="classList-name">{{ item.name }}</div>
              <div class="classList-types">{{ item.types }}</div>
              <div @click="viewRes(item, items)" class="classList-disposition pointer" style="color: #349afe">查看</div>
              <div v-if="identity == 'developer'" @click="openDrawer(item)" class="classList-disposition pointer"
                style="color: #349afe">配置</div>
              <div v-if="identity == 'developer'" @click="sidebarResourceDel(item)"
                class="classList-disposition pointer" style="color: #ff0000">删除</div>
            </div>
          </div>
        </div>
      </div>
      <!-- 侧边栏资源数据部分结束 -->
    </div>
    <!-- 教材纸质封面上传弹窗部分开始 -->
    <div v-show="showPopupPaper" class="popup-paper">
      <div v-loading="loading" element-loading-text="拼命上传中..." element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0, 0, 0, 0.7)" class="paper-content">
        <img @click="showPopupPaper = false" class="btnClose pointer" src="../../assets/btnClose.png" />
        <div class="batchUpload-title">教材上传</div>
        <!-- 教材书页部分开始 -->
        <div v-if="currentUploadType == '单个' || currentUploadType == '修改'" class="flex justify"
          style="margin-top: 20px">
          <div class="flex">
            <div class="requiredIcon">*</div>
            <div class="informationTxt">教材书页:</div>
          </div>
          <!-- 书页上传 -->
          <div class="coverBox-textbook">
            <img class="cover-textbook" :src="coverSrc1" />
            <input :value="cover_input1" class="cover-input-textbook pointer" type="file"
              accept="image/png, image/jpeg," @change="uploadWorks1" />
          </div>
        </div>
        <!-- 教材书页部分结束 -->
        <!-- 教材页码部分开始 -->
        <div v-if="currentUploadType == '单个' || currentUploadType == '修改'" class="flex align justify"
          style="margin-top: 20px">
          <div class="flex">
            <div class="requiredIcon">*</div>
            <div class="informationTxt">教材页码:</div>
          </div>
          <div class="main-content-right">
            <div class="publicInput-box flex align spaceBetween">
              <input v-model="resourcePageNum" class="publicInput" type="number" placeholder="请输入教材页码" />
            </div>
          </div>
        </div>
        <!-- 教材页码部分结束 -->
        <!-- 表格上传 -->
        <div v-if="currentUploadType == '批量'" class="flex spaceBetween" style="margin-top: 20px">
          <div class="flex">
            <div class="requiredIcon" style="opacity: 0">*</div>
            <div class="informationTxt">表格上传:</div>
          </div>
          <div class="main-content-right">
            <div class="upload-box">
              <img class="upload-img pointer" @click="btnResourcesFormImport" src="@/assets/classManagement/cm7.png" />
              <div v-show="showResourcesFormImport" class="submitSuccessfully flex align justify">
                <img class="submitSuccessfullyImg" src="@/assets/submitSuccessfully.png" />
              </div>
            </div>
          </div>
        </div>
        <!-- 资源上传 -->
        <div v-if="currentUploadType == '批量'" class="flex spaceBetween" style="margin-top: 20px">
          <div class="flex">
            <div class="requiredIcon" style="opacity: 0">*</div>
            <div class="informationTxt">教材上传:</div>
          </div>
          <div class="main-content-right">
            <div class="upload-box">
              <img class="upload-img pointer" @click="btnResourcesZipImport" src="@/assets/classManagement/cm7.png" />
              <div v-show="showResourcesZipImport" class="submitSuccessfully flex align justify">
                <img class="submitSuccessfullyImg" src="@/assets/submitSuccessfully.png" />
              </div>
            </div>
            <div class="informationTips">资源文件需上传压缩包，压缩包格式为Rar或zip。</div>
          </div>
        </div>
        <div class="flex justify pointer" style="margin-top: 17px">
          <div @click="btnPopAffirm" class="btnPopAffirm">确认</div>
        </div>
      </div>
    </div>
    <!-- 教材纸质封面上传弹窗部分结束 -->
    <!-- 侧边栏配置抽屉部分开始 -->
    <el-drawer title="AR配置" :visible.sync="drawer" :direction="direction" :before-close="handleClose">
      <div class="parentBox">
        <el-upload :accept="acceptAstrict" class="avatar-uploader" action="#" :http-request="uploadFiles"
          :show-file-list="false">
          <div class="iconBox">
            <i title="点击上传图片" v-if="!imgUrl" class="el-icon-plus avatar-uploader-icon"></i>
          </div>
        </el-upload>
        <el-image v-if="imgUrl" :src="imgUrl" fit="cover" :preview-src-list="[imgUrl]"></el-image>
        <div title="点击删除图片" v-if="imgUrl" class="gbtpBox" @click="imageRemove"><span>×</span></div>
      </div>
      <el-button @click="sidebarResourceAddAR" class="btnSave" type="primary">确定</el-button>
    </el-drawer>
    <!-- 侧边栏配置抽屉部分结束 -->
    <!-- 图片预览 -->
    <el-image style="width: 100px; height: 100px; display: none" ref="preview" :src="imgSrc"
      :preview-src-list="srcList"> </el-image>
    <!-- 外链 -->
    <div class="linkDiv" v-show="showLinkDiv">
      <img @click="btnCloseLinkDiv" class="btnClose1 pointer" src="../../assets/btnClose.png" />
      <iframe class="linkIframe" scrolling="no" :src="linkDivSrc"></iframe>
    </div>
    <!-- 音频、视频 -->
    <div class="videoDiv" v-show="showVideo">
      <img @click="btnCloseVideoDiv" class="btnClose1 pointer" src="../../assets/btnClose.png" />
      <video class="videoOrAudio" controls :src="videoSrc"></video>
    </div>
    <!-- 题目 -->
    <div class="topicDiv" v-show="showTopic">
      <img @click="btnCloseTopicDiv" class="btnClose1 pointer" src="../../assets/btnClose.png" />
      <div class="topicContent flex column justify spaceBetween">
        <div>
          <div class="flex align">
            <div class="topic-block"></div>
            <div class="topic-type">{{ topicType }}</div>
          </div>
          <div class="topic-name">{{ topicName }}</div>
          <!-- 选择题 -->
          <div v-for="(item, index) in topicOption" :key="index">
            <div
              :style="topicAnswer.indexOf(index) != -1 ? 'background: #1F96FA; color: #FFFFFF;' : 'background: #EEEEEE; color: #777777;'"
              class="topic-option">{{ optionOrder[index] }}.{{ item }}</div>
          </div>
          <!-- 简答题 -->
          <div v-show="showInputBox" class="topic-inputBox"></div>
        </div>
        <!-- 按钮 -->
        <div class="flex justify" v-show="showButton">
          <div class="flex justify spaceBetween" style="width: 410px; margin-top: 30px">
            <div @click="prevQuestion" class="pushButton pointer">上一题</div>
            <div @click="nextQuestion" class="pushButton pointer">下一题</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getTextbookCatalogue, getTextbookCatalogueData, uploadTextbookPaper, addArImg, editTextbookPaper, delTextbookPaper, delTextbookSidebar, delArImg, arImgList, getLinkResource, testPaperDetails } from "@/api";
import { Toast } from "vant";
import uploadFile from "@/utils/uploadFile1.js";
import { base64toFile, filetoBase64 } from "@/utils/util.js";
import axios from "axios";
import store from "@/store";
export default {
  data() {
    return {
      identity: "", // 登录身份
      catalogueList: [], // 目录列表
      currentCatalogueIdx: 0, // 当前目录下标
      currentCatalogueIdx1: 0, // 当前模块下标
      currentCatalogueId: 0, // 当前目录id
      resourceSrc: "", // 资源链接
      showPopupPaper: false, // 是否展示上传教材纸质封面弹窗
      textbookCataloguePaperList: [], // 教材纸质封面
      currentPaperIdx: 0, // 当前教材纸质下标
      sidebarList: [
        { name: "资源列表", value: [] },
        { name: "习题列表", value: [] },
        { name: "作业列表", value: [] },
      ],
      currentUploadType: "", // 选中的上传类型
      coverSrc1: require("../../assets/uploadCover.png"), // 教材书页地址
      cover_input1: "",
      resourcePageNum: null, // 教材页码
      formFile: "", // 上传表格的Base64
      resourcesFile: "", // 上传资源的Base64
      showResourcesFormImport: false, // 控制资源上传的表格上传成功提示的显示
      showResourcesZipImport: false, // 控制资源上传的资源上传成功提示的显示
      loading: false,
      drawer: false,
      direction: "rtl",
      acceptAstrict: ".jpg,.jpeg,.png,.JPG,.PNG", //文件上传限制
      imgUrl: "", //图片地址
      selectResource: {}, // 选中的资源
      imgSrc: "", // 图片路径
      srcList: [], // 图片列表
      linkDivSrc: "", // 外链链接
      showLinkDiv: false, // 是否展示外链
      videoSrc: "", // 音视频路径
      showVideo: false, // 是否展示video标签
      showTopic: false, // 是否展示题目
      optionOrder: ["A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M", "N", "O", "P", "Q", "R", "S", "T", "U", "V", "W", "X", "Y", "Z"],
      topicType: "", // 题目类型
      topicName: "", // 题干
      topicOption: [], // 题目选项
      topicAnswer: "", // 题目答案
      showInputBox: false, // 是否展示简答题input框
      showButton: false, // 是否显示按钮
      currentNum: 0, // 当前第几题
      testQuestionsList: [], // 试题列表
    };
  },
  created() {
    // 获取登录身份
    this.identity = this.$store.state.loginRecord.data.datas.identity;
    // 调用获取教材目录接口
    let params = { book_id: this.$store.state.textbookDetails.id };
    getTextbookCatalogue(params).then((res) => {
      if (res.data.code == 0) {
        this.catalogueList = res.data.datas;
        this.currentCatalogueId = this.catalogueList[0]?.items[this.currentPaperIdx]?.id;
        // 调用获取教材目录数据接口
        let params = {
          book_id: this.$store.state.textbookDetails.id,
          item_id: this.currentCatalogueId,
        };
        getTextbookCatalogueData(params).then((res) => {
          if (res.data.code == 0) {
            this.currentPaperIdx = 0; // 恢复当前教材纸质下标
            this.textbookCataloguePaperList = res.data.datas; // 获取教材纸质封面数据
            this.publicGetSidebarData();
          }
        });
      }
    });
  },
  methods: {
    // 关闭外链
    btnCloseLinkDiv() {
      this.showLinkDiv = false;
      this.linkDivSrc = "";
    },
    // 关闭视频、音频
    btnCloseVideoDiv() {
      // document.getElementById("box").style.overflow = "scroll";
      this.showVideo = false;
      this.videoSrc = "";
    },
    // 关闭题目
    btnCloseTopicDiv() {
      // document.getElementById("box").style.overflow = "scroll";
      this.showTopic = false;
      this.currentNum = 0;
    },
    // 上一题
    prevQuestion() {
      console.log(this.currentNum, this.testQuestionsList.length);
      if (this.currentNum > 0) {
        this.currentNum--;
        let puiblicRes = this.testQuestionsList[this.currentNum].exam_item;
        if (puiblicRes.types == "single") {
          this.topicOption = puiblicRes.options;
          this.topicAnswer = puiblicRes.answer;
          this.topicType = "单选题";
          this.showInputBox = false;
        } else if (puiblicRes.types == "multi") {
          this.topicOption = puiblicRes.options;
          this.topicAnswer = puiblicRes.answer;
          this.topicType = "多选题";
          this.showInputBox = false;
        } else if (puiblicRes.types == "truefalse") {
          this.topicType = "判断题";
          this.topicOption = ["正确", "错误"];
          this.topicAnswer = puiblicRes.answer;
          this.showInputBox = false;
        } else if (puiblicRes.types == "answer") {
          this.topicType = "简答题";
          this.topicOption = [];
          this.topicAnswer = puiblicRes.content;
          this.showInputBox = true;
        }
        this.topicName = puiblicRes.content.replace(/<[^>]+>/g, "");
      } else {
        Toast("已经是第一道题了！");
      }
    },
    // 下一题
    nextQuestion() {
      if (this.currentNum < this.testQuestionsList.length - 1) {
        this.currentNum++;
        let puiblicRes = this.testQuestionsList[this.currentNum].exam_item;
        if (puiblicRes.types == "single") {
          this.topicOption = puiblicRes.options;
          this.topicAnswer = puiblicRes.answer;
          this.topicType = "单选题";
          this.showInputBox = false;
        } else if (puiblicRes.types == "multi") {
          this.topicOption = puiblicRes.options;
          this.topicAnswer = puiblicRes.answer;
          this.topicType = "多选题";
          this.showInputBox = false;
        } else if (puiblicRes.types == "truefalse") {
          this.topicType = "判断题";
          this.topicOption = ["正确", "错误"];
          this.topicAnswer = puiblicRes.answer;
          this.showInputBox = false;
        } else if (puiblicRes.types == "answer") {
          this.topicType = "简答题";
          this.topicAnswer = puiblicRes.content;
          this.topicOption = [];
          this.showInputBox = true;
        }
        this.topicName = puiblicRes.content.replace(/<[^>]+>/g, "");
      } else {
        Toast("已经是最后一题了！");
      }
    },
    // 查看资源
    viewRes(data, items) {
      // console.log(data);
      if (data.types == "图片资源") {
        this.srcList = data.content;
        this.$refs.preview.clickHandler();
      } else if (data.types == "资源链接" || data.types == "特殊互动") {
        // this.showLinkDiv = true;
        // this.linkDivSrc = data.content[0];
        window.open(data.content[0]);
      } else if (data.types == "视频资源" || data.types == "音频资源") {
        // document.getElementById("box").style.overflow = "hidden";
        this.showVideo = true;
        this.videoSrc = data.content[0];
      } else if (data.types == "文档资源") {
        window.open(data.content[0]);
      } else if (data.types == "单选题" || data.types == "多选题") {
        // document.getElementById("box").style.overflow = "hidden";
        this.showTopic = true;
        this.topicType = data.types;
        this.topicName = data.name;
        this.topicOption = data.options;
        this.topicAnswer = data.answer;
        this.showInputBox = false;
        this.showButton = false;
      } else if (data.types == "判断题") {
        // document.getElementById("box").style.overflow = "hidden";
        this.showTopic = true;
        this.topicType = data.types;
        this.topicName = data.name;
        this.topicOption = ["正确", "错误"];
        this.topicAnswer = data.answer;
        this.showInputBox = false;
        this.showButton = false;
      } else if (data.types == "简答题") {
        // document.getElementById("box").style.overflow = "hidden";
        this.showTopic = true;
        this.topicType = data.types;
        this.topicName = data.name;
        this.topicAnswer = data.content;
        this.topicOption = [];
        this.showInputBox = true;
        this.showButton = false;
      } else if (data.types == "作业-手动" || data.types == "作业-自动") {
        this.showInputBox = false;
        let params = { id: data.id };
        testPaperDetails(params).then((res) => {
          let puiblicRes = res.data.datas.exam_items;
          this.showTopic = true;
          this.showButton = true;
          if (puiblicRes[0].exam_item.types == "single") {
            this.topicOption = puiblicRes[0].exam_item.options;
            this.topicAnswer = puiblicRes[0].exam_item.answer;
            this.topicType = "单选题";
          } else if (puiblicRes[0].exam_item.types == "multi") {
            this.topicOption = puiblicRes[0].exam_item.options;
            this.topicAnswer = puiblicRes[0].exam_item.answer;
            this.topicType = "多选题";
          } else if (puiblicRes[0].exam_item.types == "truefalse") {
            this.topicType = "判断题";
            this.topicOption = ["正确", "错误"];
            this.topicAnswer = puiblicRes[0].exam_item.answer;
          } else if (puiblicRes[0].exam_item.types == "answer") {
            this.topicType = "简答题";
            this.topicAnswer = puiblicRes[0].exam_item.content;
            this.topicOption = [];
            this.showInputBox = true;
          }
          this.topicName = puiblicRes[0].exam_item.content.replace(/<[^>]+>/g, "");
          this.testQuestionsList = res.data.datas.exam_items;
        });
      }
    },
    //上传图片
    uploadFiles(file) {
      // 调用文件大小校验方法
      if (this.beforeUpload(file.file)) {
        let formData = new FormData();
        formData.append("file", file.file);
        // 请求接口
        uploadFile(formData).then((res) => {
          if (res.code == 0) {
            this.$message({
              message: "上传成功",
              type: "success",
            });
            // 图片赋值
            this.imgUrl = res.datas;
          } else {
            // 错误信息
            this.$message({
              message: res.msg,
              type: "error",
            });
          }
        });
      }
    },
    // 文件大小校验
    beforeUpload(file) {
      if (file.size > 10 * 1024 * 1024) {
        this.$message("文件过大，请上传小于10MB的文件〜");
        return false;
      }
      return true;
    },
    // 删除图片
    imageRemove() {
      if (this.selectResource.ar_images[0]?.id) {
        let params = { id: this.selectResource.ar_images[0].id };
        delArImg(params).then((res) => {
          if (res.data.code == 0) {
            this.imgUrl = "";
            this.$message({
              message: "删除图片成功",
              type: "success",
            });
            // 调用获取教材目录数据接口
            let params = {
              book_id: this.$store.state.textbookDetails.id,
              item_id: this.currentCatalogueId,
            };
            getTextbookCatalogueData(params).then((res) => {
              if (res.data.code == 0) {
                this.currentPaperIdx = 0; // 恢复当前教材纸质下标
                this.textbookCataloguePaperList = res.data.datas; // 获取教材纸质封面数据
                this.publicGetSidebarData();
              }
            });
          }
        });
      } else {
        this.imgUrl = "";
        this.$message({
          message: "删除图片成功",
          type: "success",
        });
      }
    },
    handleClose(done) {
      this.$confirm("确认关闭？")
        .then((_) => {
          done();
        })
        .catch((_) => { });
    },
    // 资源表格导入
    btnResourcesFormImport() {
      let input = document.createElement("input"); // 创建一个input标签
      document.body.appendChild(input);
      input.style.display = "none";
      input.type = "file"; // 类型改成file 上传文件
      input.accept = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"; // 接受类型
      input.click(); // 触发点击事件 调起文件夹
      input.onchange = (event) => {
        if (!event.target.files || !event.target.files[0]) {
          reject("未选择文件");
        } else {
          this.formFile = event.target.files[0]; // 文件路径
          this.showResourcesFormImport = true;
        }
      };
    },
    // 资源压缩包导入
    btnResourcesZipImport() {
      let input = document.createElement("input"); // 创建一个input标签
      document.body.appendChild(input);
      input.style.display = "none";
      input.type = "file"; // 类型改成file 上传文件
      input.accept = "*"; // 接受类型
      input.click(); // 触发点击事件 调起文件夹
      input.onchange = (event) => {
        if (!event.target.files || !event.target.files[0]) {
          reject("未选择文件");
        } else {
          this.resourcesFile = event.target.files[0]; // 文件路径
          this.showResourcesZipImport = true;
        }
      };
    },
    // 侧边栏数据获取
    publicGetSidebarData() {
      this.sidebarList = [
        { name: "资源列表", value: [] },
        { name: "习题列表", value: [] },
        { name: "作业列表", value: [] },
      ];

      if (this.textbookCataloguePaperList[this.currentPaperIdx]?.exts) {
        for (let i = 0; i < this.textbookCataloguePaperList[this.currentPaperIdx]?.exts.length; i++) {
          let publicRes = this.textbookCataloguePaperList[this.currentPaperIdx]?.exts[i];
          if (publicRes.types == "assets") {
            if (publicRes.assets.types == "video") {
              publicRes.assets.types = "视频资源";
            } else if (publicRes.assets.types == "audio") {
              publicRes.assets.types = "音频资源";
            } else if (publicRes.assets.types == "doc") {
              publicRes.assets.types = "文档资源";
            } else if (publicRes.assets.types == "image") {
              publicRes.assets.types = "图片资源";
            } else if (publicRes.assets.types == "web") {
              publicRes.assets.types = "资源链接";
            } else if (publicRes.assets.types == "h5") {
              publicRes.assets.types = "特殊互动";
            }
            publicRes.assets.link_id = publicRes.id;
            publicRes.assets.link_lesson_res_id = publicRes.link_lesson_res_id;
            publicRes.assets.ar_images = publicRes.ar_images || [];
            publicRes.assets.score = publicRes.assets.score + "分"; // 分值
            this.sidebarList[0].value.push(publicRes.assets);
          } else if (publicRes.types == "examitem") {
            if (publicRes.exam_item.types == "single") {
              publicRes.exam_item.types = "单选题";
            } else if (publicRes.exam_item.types == "multi") {
              publicRes.exam_item.types = "多选题";
            } else if (publicRes.exam_item.types == "truefalse") {
              publicRes.exam_item.types = "判断题";
            } else if (publicRes.exam_item.types == "answer") {
              publicRes.exam_item.types = "简答题";
            }
            publicRes.exam_item.link_id = publicRes.id;
            publicRes.exam_item.link_lesson_res_id = publicRes.link_lesson_res_id;
            publicRes.exam_item.score = publicRes.exam_item.score + "分"; // 分值
            publicRes.exam_item.name = publicRes.exam_item.content;
            publicRes.exam_item.ar_images = publicRes.ar_images || [];
            this.sidebarList[1].value.push(publicRes.exam_item);
          } else if (publicRes.types == "exam") {
            if (publicRes.exam.types == "manual") {
              publicRes.exam.types = "作业-手动";
            } else if (publicRes.exam.types == "auto") {
              publicRes.exam.types = "作业-自动";
            }
            publicRes.exam.link_id = publicRes.id;
            publicRes.exam.link_lesson_res_id = publicRes.link_lesson_res_id;
            publicRes.exam.score = publicRes.exam.score + "分"; // 分值
            publicRes.exam.ar_images = publicRes.ar_images || [];
            this.sidebarList[2].value.push(publicRes.exam);
          }
        }
      }
    },
    // 选择目录
    selectCatalogue(index, index1) {
      this.currentCatalogueId = this.catalogueList[index]?.items[index1]?.id; // 获取当前目录id
      console.log(this.currentCatalogueId);
      this.currentCatalogueIdx = index;
      this.currentCatalogueIdx1 = index1;
      // 调用获取教材目录数据接口
      let params = {
        book_id: this.$store.state.textbookDetails.id,
        item_id: this.currentCatalogueId,
      };
      getTextbookCatalogueData(params).then((res) => {
        if (res.data.code == 0) {
          this.currentPaperIdx = 0; // 恢复当前教材纸质下标
          this.textbookCataloguePaperList = res.data.datas; // 获取教材纸质封面数据
          this.publicGetSidebarData();
        }
      });
    },
    // 上传教材书页
    uploadWorks1(e) {
      this.hide = true;
      var file = e.target.files[0];
      this.cover_input1 = ""; // input标签的change触发规则
      if (!file) return;
      const reader = new FileReader();
      reader.onload = (res) => {
        this.coverSrc1 = res.target.result;
        let str1 = base64toFile(this.coverSrc1, "file"); //base64图片格式转文件流
        let formData = new FormData();
        formData.append("file", str1);
        uploadFile(formData).then((res) => {
          this.resourceSrc = res.datas;
        });
      };
      reader.readAsDataURL(file);
    },
    // 教材纸质封面上传
    textbookUpload(type) {
      if (type == "修改") {
        this.resourceSrc = this.textbookCataloguePaperList[this.currentPaperIdx]?.assets.content[0];
        this.coverSrc1 = this.textbookCataloguePaperList[this.currentPaperIdx]?.assets.content[0];
        this.resourcePageNum = this.textbookCataloguePaperList[this.currentPaperIdx]?.sort;
        this.showPopupPaper = true;
        this.currentUploadType = type; // 获取选中上传类型
      } else {
        this.resourceSrc = "";
        this.showPopupPaper = true;
        this.currentUploadType = type; // 获取选中上传类型
        this.showResourcesFormImport = false;
        this.showResourcesZipImport = false;
      }
    },
    // 教材纸质封面删除
    textbookDel() {
      this.$confirm("此操作将永久删除该纸质封面, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          // 调用教材纸质封面上传接口
          let params = { link_id: this.textbookCataloguePaperList[this.currentPaperIdx].id };
          delTextbookPaper(params).then((res) => {
            if (res.data.code == 0) {
              this.$message({
                type: "success",
                message: "删除成功!",
              });
              // 调用获取教材目录数据接口
              let params = {
                book_id: this.$store.state.textbookDetails.id,
                item_id: this.currentCatalogueId,
              };
              getTextbookCatalogueData(params).then((res) => {
                if (res.data.code == 0) {
                  this.currentPaperIdx = 0; // 恢复当前教材纸质下标
                  this.textbookCataloguePaperList = res.data.datas; // 获取教材纸质封面数据
                }
              });
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    // 打开AR配置抽屉
    openDrawer(data) {
      this.drawer = true;
      this.selectResource = data;
      console.log(data);
      this.imgUrl = data.ar_images[0]?.url;
    },
    // 侧边栏资源配置AR图片
    sidebarResourceAddAR() {
      if (this.imgUrl == "") {
        this.$message({
          type: "info",
          message: "请先上传图片！",
        });
      } else {
        if (this.selectResource.ar_images.length == 0) {
          // 调用AR图片添加接口
          let params = { url: this.imgUrl, link_book_id: this.selectResource.link_id };
          addArImg(params).then((res) => {
            if (res.data.code == 0) {
              Toast("已上传！");
              this.drawer = false;
              // 调用获取教材目录数据接口
              let params = {
                book_id: this.$store.state.textbookDetails.id,
                item_id: this.currentCatalogueId,
              };
              getTextbookCatalogueData(params).then((res) => {
                if (res.data.code == 0) {
                  this.currentPaperIdx = 0; // 恢复当前教材纸质下标
                  this.textbookCataloguePaperList = res.data.datas; // 获取教材纸质封面数据
                  this.publicGetSidebarData();
                }
              });
            }
          });
        } else {
          // 调用AR图片添加接口
          let params = { url: this.imgUrl, ar_id: this.selectResource.ar_images[0].id };
          addArImg(params).then((res) => {
            if (res.data.code == 0) {
              Toast("已上传！");
              this.drawer = false;
              // 调用获取教材目录数据接口
              let params = {
                book_id: this.$store.state.textbookDetails.id,
                item_id: this.currentCatalogueId,
              };
              getTextbookCatalogueData(params).then((res) => {
                if (res.data.code == 0) {
                  this.currentPaperIdx = 0; // 恢复当前教材纸质下标
                  this.textbookCataloguePaperList = res.data.datas; // 获取教材纸质封面数据
                  this.publicGetSidebarData();
                }
              });
            }
          });
        }
      }
    },
    // 侧边栏资源删除
    sidebarResourceDel(data) {
      console.log(data);
      this.$confirm("此操作将删除该资源, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          // 调用教材纸质封面上传接口
          let params = { link_id: data.link_id };
          delTextbookSidebar(params).then((res) => {
            if (res.data.code == 0) {
              this.$message({
                type: "success",
                message: "删除成功!",
              });
              // 调用获取教材目录数据接口
              let params = {
                book_id: this.$store.state.textbookDetails.id,
                item_id: this.currentCatalogueId,
              };
              getTextbookCatalogueData(params).then((res) => {
                if (res.data.code == 0) {
                  this.currentPaperIdx = 0; // 恢复当前教材纸质下标
                  this.textbookCataloguePaperList = res.data.datas; // 获取教材纸质封面数据
                  this.publicGetSidebarData();
                }
              });
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    // 教材纸质封面上传确定按钮
    btnPopAffirm() {
      console.log(this.formFile, this.resourcesFile);
      if (this.resourceSrc == "" && this.currentUploadType == "单个") {
        Toast("请先上传书页！");
      } else if (this.resourcePageNum == null && this.currentUploadType == "单个") {
        Toast("请先输入教材页码！");
      } else {
        if (this.currentUploadType == "批量") {
          this.loading = true;
          // 调用教材资源上传导入接口
          let formData = new FormData();
          formData.append("file", this.formFile); // 加入文件流参数
          formData.append("zip", this.resourcesFile); // 加入文件流参数
          formData.append("book_item_id", this.currentCatalogueId); // 加入课次id参数
          axios
            .post(store.state.interfacePath + "api/import/book", formData, {
              headers: {
                "user-token": this.$store.state.loginRecord.data.ext,
                "Content-Type": "multipart/form-data",
              },
            })
            .then((response) => {
              let res = response.data;
              if (res.code == 0) {
                this.loading = false;
                this.formFile = ""; // 清空表格路径
                this.resourcesFile = ""; // 清空教材压缩包路径
                this.showPopupPaper = false;
                // 调用获取教材目录数据接口
                let params = {
                  book_id: this.$store.state.textbookDetails.id,
                  item_id: this.currentCatalogueId,
                };
                getTextbookCatalogueData(params).then((res) => {
                  if (res.data.code == 0) {
                    this.currentPaperIdx = 0; // 恢复当前教材纸质下标
                    this.textbookCataloguePaperList = res.data.datas; // 获取教材纸质封面数据
                  }
                });
              } else {
                this.loading = false;
                Toast("上传失败！");
              }
            })
            .catch((response) => {
              console.log(response);
            });
        } else if (this.currentUploadType == "单个") {
          // 调用教材纸质封面上传接口
          let params = { url: this.resourceSrc, book_item_id: this.currentCatalogueId, sort: this.resourcePageNum };
          uploadTextbookPaper(params).then((res) => {
            if (res.data.code == 0) {
              Toast("已上传！");
              this.showPopupPaper = false;
              this.resourceSrc = "";
              this.resourcePageNum = null;
              this.coverSrc1 = require("../../assets/uploadCover.png");
              // 调用获取教材目录数据接口
              let params = {
                book_id: this.$store.state.textbookDetails.id,
                item_id: this.currentCatalogueId,
              };
              getTextbookCatalogueData(params).then((res) => {
                if (res.data.code == 0) {
                  this.currentPaperIdx = 0; // 恢复当前教材纸质下标
                  this.textbookCataloguePaperList = res.data.datas; // 获取教材纸质封面数据
                }
              });
            }
          });
        } else if (this.currentUploadType == "修改") {
          // 调用教材纸质封面上传接口
          let params = { url: this.resourceSrc, link_id: this.textbookCataloguePaperList[this.currentPaperIdx].id, sort: this.resourcePageNum };
          editTextbookPaper(params).then((res) => {
            if (res.data.code == 0) {
              Toast("已修改！");
              this.showPopupPaper = false;
              this.resourceSrc = "";
              this.resourcePageNum = null;
              this.coverSrc1 = require("../../assets/uploadCover.png");
              // 调用获取教材目录数据接口
              let params = {
                book_id: this.$store.state.textbookDetails.id,
                item_id: this.currentCatalogueId,
              };
              getTextbookCatalogueData(params).then((res) => {
                if (res.data.code == 0) {
                  this.currentPaperIdx = 0; // 恢复当前教材纸质下标
                  this.textbookCataloguePaperList = res.data.datas; // 获取教材纸质封面数据
                }
              });
            }
          });
        }
      }
    },
    // 向左切换
    iconLeftToggle() {
      this.currentPaperIdx--;
      this.publicGetSidebarData();
    },
    // 向右切换
    iconRightToggle() {
      this.currentPaperIdx++;
      this.publicGetSidebarData();
    },
    // 从教学资源库添加
    addFromResource() {
      this.$router.push({ name: "resourceManagement", params: { method: "handMovement", link_book_id: this.textbookCataloguePaperList[this.currentPaperIdx].id } });
    },
  },
};
</script>

<style scoped src="./index.css"></style>
